import cuckoo from "../../services/cuckoo/cuckoo"
import { parseQuery } from "../../services/query/queries"
import * as utm from "../../../../app/scripts/tools/utm"

export const KAYAK_CLICK_ID = "kayakClickId"
export const SUB1_PARAM = "sub1"

type Options = {
  canClearTrackers?: boolean
}

const initAffiliates = (options?: Options) => {
  // Kayak
  // FIXME: cmp2 should be tracked the same as kayak but clickid is not present
  // isSubAffilId(affilid, "cmp2")
  // ===
  // @ts-expect-error: Flow to TS migration.
  let kayakClickId = window.getEnvParameter("clickid")
  // @ts-expect-error: Flow to TS migration.
  const sub1Param = window.getEnvParameter("sub1")
  // @ts-expect-error: Flow to TS migration.
  const isRedirectedFromAsyncPayment = window.getEnvParameter("cb")
  if (navigator.cookieEnabled) {
    if (kayakClickId) {
      // Requested by Kayak to escape `web-` & `mobile-` prefixes from clickId
      // "web-FKCUevTjrZbFS5IisfHz3w" => "FKCUevTjrZbFS5IisfHz3w"
      kayakClickId = kayakClickId.replace("web-", "").replace("mobile-", "")

      window.sessionStorage.setItem(KAYAK_CLICK_ID, kayakClickId)
    }
    if (!kayakClickId && options?.canClearTrackers && !isRedirectedFromAsyncPayment) {
      window.sessionStorage.removeItem(KAYAK_CLICK_ID)
    }

    if (sub1Param) {
      window.sessionStorage.setItem(SUB1_PARAM, sub1Param)
    }
  }

  // UTM params
  // ===
  utm.saveToSession(cuckoo, parseQuery(document.location.search))
}

export default initAffiliates
